import { Badge, Tooltip } from 'antd';
import clsx from 'clsx';
import { NotificationProps } from '../notification.types';
import { RiCheckFill } from 'react-icons/ri';
import { NOTIFICATION_TYPE } from '@shared/constants';
import { getNotificationDate } from '../notification-helper';
import { useState } from 'react';
import { useScreenSize } from '@shared/hooks/use-screen';
import { AppAvatar } from '@components/app-avatar';
import { useTranslation } from 'react-i18next';
import { attributesParser, replacementAttributesObj } from './notification-card.utils';

export function NotificationCard(props: NotificationProps) {
  const { notification, markSingleRead, onClickNotification, handleMarkedNotification, isFirstItem } = props;
  const { markSingleReadHandler } = markSingleRead;
  const dynamicTextObj = replacementAttributesObj(notification);
  const { isMobile } = useScreenSize();
  const { t } = useTranslation();

  const [notificationMarked, setNotificationMarked] = useState(false);
  const pushNotification = [NOTIFICATION_TYPE.SOFTWARE_MAINTENANCE, NOTIFICATION_TYPE.FEATURE_UPDATE];
  return (
    <div
      tabIndex={isMobile ? 0 : undefined}
      className={clsx('relative group hover:bg-gray-100 cursor-pointer overflow-hidden', {
        'bg-gray-200': notificationMarked,
      })}
      style={{
        backgroundColor: !notification?.seenAt ? 'color-mix(in srgb, var(--color-gray-100) 60%, transparent)' : '',
      }}
      onClick={onClickNotification(notification)}
    >
      <div className="flex gap-4 pl-5 pb-3">
        <div className="pt-3">
          <Badge dot={!notification?.seenAt} offset={[-6, 6]}>
            <AppAvatar src={notification?.imageUrl} size={36} />
          </Badge>
        </div>
        <div
          className={clsx(
            'group-hover:scale-105 duration-300 transition wrap-anywhere leading-4 flex-1 pr-5 pt-3',
            !isFirstItem && 'border-t border-gray-300'
          )}
        >
          {pushNotification.includes(notification?.type || '') ? (
            <p className="text-7.5 text-text-800">{notification?.title}</p>
          ) : null}

          <p
            className="text-[15px] leading-4.75 font-normal text-text-900"
            dangerouslySetInnerHTML={{ __html: attributesParser(notification, dynamicTextObj) ?? '' }}
          />
          <p className="text-text-500 text-[13px] leading-3.5 font-medium mt-1.5">
            {getNotificationDate(notification?.createdAt)}
          </p>
        </div>
      </div>
      <div
        className={clsx(
          'transition-all invisible group-hover:visible group-hover:animate-appear-top-xs',
          isMobile && 'group-focus:visible group-focus:animate-appear-top-xs',
          'absolute right-3 top-3'
        )}
      >
        <Tooltip title={isMobile ? '' : notificationMarked ? t('mark_as_unread') : t('mark_as_read')}>
          <div
            className="group/tick rounded-full bg-gray-600 hover:bg-primary-50 p-1 shadow hover:scale-125 duration-100"
            onClick={(e) => {
              e?.stopPropagation();
              markSingleReadHandler(notification?.id);
              setNotificationMarked(!notificationMarked);
              handleMarkedNotification(notification?.id || 0);
            }}
          >
            <RiCheckFill size={20} className="text-text-400 group-hover/tick:text-primary-400" />
          </div>
        </Tooltip>
      </div>
    </div>
  );
}
